import { Grommet, ThemeType } from "grommet";
import { useContext, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useImmer } from 'use-immer';
import "./App.css";
import { LoadingIndicator } from "./components/LoadingIndicator";
import { NewReport } from "./components/NewReport";
import {
  RealmContext,
  RealmCredentialsType,
  RealmProvider,
} from "./components/providers/RealmProvider";
import { ClientWrapper } from "./components/wrappers/ClientWrapper";
// import defaultTheme from './theme.json';
import { theme as defaultTheme } from "./theme";

function App() {
  const [ theme, setTheme ] = useImmer<ThemeType>(defaultTheme);
  useEffect(() => {
    // console.log('theme update');
    setTheme(defaultTheme);
  }, [defaultTheme]);

  return (
    <Grommet full theme={theme}>
      <BrowserRouter>
        <RealmProvider appId={import.meta.env.VITE_REALM_APP_ID} remember={false}>
          <RealmProvider.IsLoggedOut>
            <AutoLogin />
          </RealmProvider.IsLoggedOut>
          <RealmProvider.IsLoggedIn>
            <Routes>
              <Route path=":client" element={<ClientWrapper setTheme={setTheme}/>}>
                <Route index element={<NewReport/>}/>
                <Route path=":type" element={<NewReport/>}/>
              </Route>
            </Routes>
          </RealmProvider.IsLoggedIn>
        </RealmProvider>
      </BrowserRouter>
    </Grommet>
  );
}

export default App;

function AutoLogin() {
  const { isLoggedIn, login } = useContext(RealmContext);

  useEffect(() => {
    if (!isLoggedIn) {
      login(RealmCredentialsType.anonymous);
    }
  }, [isLoggedIn, login]);

  return <LoadingIndicator />;
}
